import { render, staticRenderFns } from "./Odontograma.vue?vue&type=template&id=54bcae5d&"
import script from "./Odontograma.vue?vue&type=script&lang=js&"
export * from "./Odontograma.vue?vue&type=script&lang=js&"
import style0 from "./Odontograma.vue?vue&type=style&index=0&id=54bcae5d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports